import { ADVANCE_TURN, RESET_ATF } from '../../actions/game/activeTime.actions'

const initialState = {
    turn: -1,
    tick: -1,
    status: 'running',
}

const activeTimeReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case ADVANCE_TURN: {
            const { turn } = state
            const { tick } = payload
            return {
                ...state,
                turn: turn + 1,
                tick,
            }
        }

        case RESET_ATF: {
            return initialState
        }

        default: {
            return state
        }
    }
}

export default activeTimeReducer
